import React, { Fragment } from 'react';
import { Button, Grid } from '@mui/material';
import { useHistory } from 'react-router';
import { withTranslation } from 'react-i18next';
import { Trans } from 'react-i18next';

const EMarketStorefrontReturn = props => {
    const history = useHistory();
    const {t} = props;

    const redirect = sessionStorage.getItem('paymentRedirect') || null

    return (
        <Fragment>
            <h1> {t('EMarket.Success')} </h1>

            <br />
            <p> {t('EMarket.ReturnMessage1')}</p>
            <p> <Trans
                i18nKey={"EMarket.ReturnMessage2"}
                components={[<a href="mailto:gi.bmp@ifas.ufl.edu">placeholder</a>]}
                /> 
            </p>
                <Grid container spacing={3} >
                    {redirect &&
                        <Grid item xs={12} sm={3} md={2}>
                            <Button
                                style={{ textAlign: "center", alignSelf: "flex-end" }}
                                onClick={() => { history.push(redirect) }}
                                variant="outlined"
                                color="primary">
                                {t('EMarket.CONTINUE')}
                            </Button>
                        </Grid>
                    }
                </Grid>


        </Fragment>
    )
}


export default withTranslation()(EMarketStorefrontReturn);